import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './NavBar.css';

const NavBar = () => {
  const { pathname } = useLocation();
  const routes = ['/', '/projects', '/activity', '/art', '/cv'];
  const activeIndex = Math.max(routes.indexOf(pathname), 0);

  return (
    <nav
      className="site-nav"
      style={{ '--active-index': activeIndex }}
    >
      <NavLink to="/">Home</NavLink>
      <NavLink to="/projects">Projects</NavLink>
      <NavLink to="/activity">Activities</NavLink>
      <NavLink to="/art">Art</NavLink>
      <NavLink to="/cv">CV</NavLink>
    </nav>
  );
};

export default NavBar;
